import * as React from 'react';
import { EnrollIcon, MinusIcon, RemoveIcon, ApprovalsIcon } from 'foundations-assets';
const getOverridePropsForUnenrollmentEvent = log => {
  return {
    icon: log.failType ? RemoveIcon : ApprovalsIcon,
    backgroundColor: log.failType ? 'fill-alert-default' : 'fill-positive-default',
    borderColor: log.failType ? 'border-alert-default' : 'fill-positive-default',
    color: 'icon-primary-on-fill-default'
  };
};
const getOverridePropsForLogEvent = log => {
  switch (log.type) {
    case 'ENROLLMENT':
      return {
        icon: EnrollIcon,
        backgroundColor: 'fill-positive-pressed',
        borderColor: 'fill-positive-pressed',
        color: 'icon-primary-on-fill-default'
      };
    case 'UNENROLLMENT':
      return getOverridePropsForUnenrollmentEvent(log);
    case 'PRE_ENROLLMENT':
      return {
        icon: MinusIcon,
        backgroundColor: 'fill-accent-yellow-default',
        borderColor: 'border-caution-default',
        color: 'icon-primary-on-fill-default'
      };
    default:
      return {};
  }
};
const EnrollmentTimelineItemIcon = ({
  logItem,
  defaultIcon,
  size
}) => {
  const props = getOverridePropsForLogEvent(logItem.data);
  return /*#__PURE__*/React.cloneElement(defaultIcon, Object.assign({}, props, {
    size
  }));
};
export default EnrollmentTimelineItemIcon;